import React from "react"
import { mq, Text, textStyles, theme } from "@pallet-hq/hegel"
import CheckLabel from "@pallet/components/CheckLabel"
import styled from "@emotion/styled"
import { useTheme } from "@emotion/react"

const ContingencyTierFeaturesSection = () => {
    // @ts-ignore
    const { colors } = useTheme()
    return (
        <MainWrapper color={colors.primary}>
            <TitleText>Features</TitleText>
            <CheckLabel
                label="Access to talent database"
                enabled={true}
                textColor={theme.colors.gray100}
                iconColor={theme.colors.gray100}
            />
            <CheckLabel
                label="Custom outreach to my network"
                enabled={true}
                textColor={theme.colors.gray100}
                iconColor={theme.colors.gray100}
            />
            <CheckLabel
                label="Dedicated sourcing support"
                enabled={true}
                textColor={theme.colors.gray100}
                iconColor={theme.colors.gray100}
            />
        </MainWrapper>
    )
}

export default ContingencyTierFeaturesSection

const MainWrapper = styled.div<{ color: string }>`
    display: flex;
    flex-direction: column;
    padding: ${theme.space.small} ${theme.space.medium} ${theme.space.large};
    background: ${theme.colors.gray800};
    border-radius: 0 0 8px 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12);
    box-sizing: border-box;
    width: 100%;
    ${mq({
        maxWidth: ["none", "304px"],
        gridRow: [undefined, 3],
        marginBottom: [theme.space.medium, undefined],
    })};
    gap: ${theme.space.small};
    border: 1px solid ${theme.colors.gray800};
`

const TitleText = styled(Text)`
    ${textStyles.uiSmall500};
    color: ${theme.colors.gray500};
`
